import { render, staticRenderFns } from "./EventUsers.vue?vue&type=template&id=44c298d5&"
import script from "./EventUsers.vue?vue&type=script&lang=js&"
export * from "./EventUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports